import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

/** Custom “show password” eye from design (fills with `currentColor`). */
export default function PasswordShowEye(props: SvgIconProps) {
  const { sx, ...rest } = props;
  return (
    <SvgIcon {...rest} viewBox="0 0 22 15" sx={{ width: 22, height: 15, ...sx }}>
      <path
        d="M11.09 15c4.823 0 8.574-3.875 10.181-6.125.67-.875.67-2 0-2.875-1.607-2.125-5.358-6-10.18-6C6.268 0 2.518 3.875.91 6.125c-.67.875-.67 2 0 2.75C2.518 11.125 6.268 15 11.09 15zm0-11.25c2.278 0 4.02 1.625 4.02 3.75s-1.742 3.75-4.02 3.75c-2.277 0-4.018-1.625-4.018-3.75s1.741-3.75 4.019-3.75z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
